<template>
  <div class="norem locator-verify-wrapper">
    <mobile-header :title="$t('FoodB_0526_CJIS_cGuT')" />
    <div class="page-container">
      <!-- 进度条 -->
      <progress-steps
        :steps="[
          $t('FoodB_0526_obJO_XULq', { number1: 1 }), // FoodB_0526_obJO_XULq 步骤{{number1}}
          $t('FoodB_0526_BiXD_Hdyk', { number2: 2 }), // FoodB_0526_BiXD_Hdyk 步骤{{number2}}/ FoodB_0526_xxjK_BrKm 验证客户确认码
        ]"
        :current-step="0"
      />
      <!-- FoodB_0526_YWxv_qCMp 验证订单查询码 -->
      <div class="guide-title">{{ $t('FoodB_0526_YWxv_qCMp') }}</div>
      <!-- FoodB_0526_rIpi_tOxQ 订单定位码可以在订单收据上找到，它由8位数字组成。它可以用来识别订单，也可以作为联系用户的分机号码。 -->
      <div class="guide-text">{{ $t('FoodB_0526_rIpi_tOxQ', { number3: 8 }) }}</div>
      <!-- 引导说明 -->
      <div class="guide-section">
        <div class="receipt-guide">
          <img src="@/assets/images/receipt-guide.png" alt="Receipt Guide" class="receipt-image" />
        </div>
      </div>

      <!-- 输入框 -->
      <div class="input-section">
        <verification-code-input
          v-model="locatorCode"
          :has-error="locatorCodeError"
          :length="8"
          @change="handleInput"
        />
      </div>

      <!-- 按钮 -->
      <div class="action-button">
        <go-button :disabled="!isValidLocator" :loading="loading" @click="handleVerify">
          <!-- FoodB_0526_ALSJ_vOIv 验证并继续 -->
          {{ $t('FoodB_0526_ALSJ_vOIv') }}
        </go-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyLocator } from './api'
import VerificationCodeInput from '@/components/verification-code-input'
import ProgressSteps from '@/components/progress-steps'
import Track from '@/utils/track'
import MobileHeader from '@/components/mobile-header'

export default {
  name: 'LocatorVerify',
  components: {
    VerificationCodeInput,
    ProgressSteps,
    MobileHeader,
  },
  data() {
    return {
      locatorCode: '',
      isValidLocator: false,
      locatorCodeError: false,
      loading: false,
    }
  },
  watch: {
    locatorCode(value) {
      this.locatorCodeError = false
    },
  },
  methods: {
    handleInput(value) {
      this.isValidLocator = value.length === 8
    },
    async handleVerify() {
      try {
        if (!this.isValidLocator) return
        this.loading = true
        const { errno, errmsg, data } = await verifyLocator({ locator: this.locatorCode })
        this.loading = false
        if (errno === 0) {
          const { code, msg, orderId, shopId } = data || {}
          switch (code) {
            case 1: // 验证成功，进入下一步
              Track.deliveringVerifyAndContinueClick({
                shop_id: shopId,
                order_id: orderId,
              })
              this.$router.push({
                path: '/confirmation-entrega/delivery-code',
                query: { orderId, locator: this.locatorCode, shopId },
              })
              break
            case 2: // 订单完成，跳转到完成页面
              this.$router.push({
                path: '/confirmation-entrega/completed',
                query: { orderId, shopId },
              })
              break
            case 3: // 异常情况
              this.locatorCodeError = true
              this.$createGoToast({
                // FoodB_0526_ItLx_NtXl 输入的查询码未识别，请重试。
                text: msg || this.$t('FoodB_0526_ItLx_NtXl'),
              }).show()
              break
          }
        } else {
          this.$createGoToast({
            // FoodB_0526_ItLx_NtXl 输入的查询码未识别，请重试。
            text: errmsg || this.$t('FoodB_0526_ItLx_NtXl'),
          }).show()
        }
      } catch (error) {
        this.loading = false
        console.log('error', error)
        this.$createGoToast({
          // FoodB_0526_ItLx_NtXl 输入的查询码未识别，请重试。
          text: this.$t('FoodB_0526_ItLx_NtXl'),
        }).show()
      }
    },
  },
  mounted() {
    Track.deliveringVerify2StepsShow()
  },
}
</script>

<style lang="scss" scoped>
.locator-verify-wrapper {
  background-color: #fff;

  .page-container {
    max-width: 750px;
    margin: 0 auto;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .page-title {
    margin-top: 40px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 48px;
    color: #0b0b0d;
    letter-spacing: 0;
    text-align: center;
    line-height: 56px;
    font-weight: 700;
    margin-bottom: 32px;
    width: 722px;
  }

  .guide-title {
    margin-top: 40px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 48px;
    color: #0b0b0d;
    letter-spacing: 0;
    text-align: center;
    line-height: 56px;
    font-weight: 700;
    margin-bottom: 32px;
  }

  .receipt-guide {
    margin-top: 40px;
    .receipt-image {
      width: 100%;
      margin-bottom: 16px;
    }

    .guide-text {
      font-family: DiDiSans-Pro-Regular;
      font-size: 32px;
      color: #0b0b0d;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
}

.input-section {
  width: 100%;
  max-width: 400px;
  margin-bottom: 60px;
}

.action-button {
  width: 100%;
}
</style>
